module.exports = __webpack_public_path__ + "assets/img/2-3.4ca0abed.png";